import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import ProductCartItem from "components/ProductCartItem";
import CancelIcon from "@material-ui/icons/Cancel";
import Promotion from "components/Promotion";

const PromotionItem = props => {
	const classes = useStyles();
	const {
		product,
		handleDeleteProduct,
		listProductSelect,
		setListProductSelect,
		handleOnBlur,
		handleOnFocus
	} = props;

	const productDetail = listProductSelect.find(
		item => item.id === product.id
	);

	const handleChangeValue = e => {
		const { name, value } = e.target;
		const data = listProductSelect.map(item => {
			if (item.id === product.id) {
				if (name === "THUNG") {
					return {
						...item,
						totalBox: Number(value === "" ? 0 : value)
					};
				} else {
					return {
						...item,
						totalDetail: Number(value === "" ? 0 : value)
					};
				}
			} else {
				return { ...item };
			}
		});
		setListProductSelect(data);
	};

	return (
		<Grid
			classes={{ root: classes.root }}
			onClick={() => {
				handleOnBlur();
			}}
		>
			<CancelIcon
				classes={{ root: classes.btnDelete }}
				onClick={() => {
					handleDeleteProduct(product);
				}}
			/>
			<Promotion product={product} />
			<ProductCartItem
				product={product}
				productDetail={productDetail}
				handleChangeValue={handleChangeValue}
				handleOnFocus={handleOnFocus}
			/>
		</Grid>
	);
};

export default memo(PromotionItem);
